/** Presentation descriptions, keyed to existing source entries; no source field is rewritten. */
export const informationAcquisition: Readonly<Record<string, string>> = {
  'HRF-IR-01': '建筑档案、报警地址和经核实的定位记录；核对建筑身份与时间。',
  'HRF-IR-02': '建筑竣工图、楼层平面图与现场核查记录；标明图纸版本。',
  'HRF-IR-03': '建筑用途档案、物业资料与人员报告；用途不等于实时在场人数。',
  'HRF-IR-04': '带位置和时间的人员报告、观察影像与消防系统记录；区分观察与推测。',
  'HRF-IR-05': '带时间的现场观察、视频及适配传感器记录；图像不提供气体成分。',
  'HRF-IR-06': '求助报告、现场人员核实与联络记录；保留未确认人数和位置。',
  'HRF-IR-07': '疏散图、出口管理与现场障碍核查记录；地图不能证明通行安全。',
  'HRF-IR-08': '消防控制室值班、设施维护和检测记录；状态应由责任人员核实。',
  'HRF-IR-11': '建筑结构图、带位置的异常观察及专业评估资料；不由影像得出安全结论。',
};

export const unboundCapabilityReading: Readonly<
  Record<string, { output: string; implementation: string; limit: string }>
> = {
  'HRF-CR-01': {
    output: '经专业确认的高处接近或撤离支持及过程记录',
    implementation: '具备资质的专业队伍、适配的高处作业装备与建筑设施',
    limit: '本页未核定任何路线、器材或到达条件，不提供现场撤离方案。',
  },
  'HRF-CR-02': {
    output: '满足实际环境与授权要求时对燃烧的物理抑制及状态记录',
    implementation: '建筑既有灭火设施及专业队伍的适配装备',
    limit: '系统可用性、进入、供水与操作权限均待确认；远程水炮不等于室内整体抑制能力。',
  },
  'HRF-CR-19': {
    output: '经责任人员确认的区域管控与交通组织记录',
    implementation: '依法履职的人员、警示设施与交通组织措施',
    limit: '不计算警戒距离，不指定封控范围；实施权限与范围由现场专业责任方确定。',
  },
};
